module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-CommandBar",
    staticStyle: {
      "margin-top": "45px",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_vm._v("全按钮")]), _vm._v(" "), _c('mt-command-bar', {
    attrs: {
      "buttons": _vm.buttons,
      "moreButtons": _vm.moreButtons
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_vm._v("没有更多按钮")]), _vm._v(" "), _c('mt-command-bar', {
    attrs: {
      "buttons": _vm.buttons
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c764cce","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/command-bar.vue
// module id = 115
// module chunks = 0